import React from "react";
import Page, { PageProps } from "../../../core/ui/pages/Page";
import { ILoginPresenter } from "../../presenter/LoginPresenter";
import Text from "antd/lib/typography/Text";

export interface Props extends PageProps {}
export interface State extends ILoginPresenter {}

export default class LogoutPage extends React.Component<Props, State> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    let { translate } = this.state;
    return (
      <Page {...this.props}>
        <Text style={{ fontSize: 30, color: "#8D8D8D", fontWeight: "bold" }}>
          {translate("login.logging_out")}
        </Text>
      </Page>
    );
  }
}
